"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Icon(_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.viewBox, viewBox = _d === void 0 ? '0 0 24 24' : _d, _e = _a.color, color = _e === void 0 ? 'currentColor' : _e, children = _a.children;
    return (react_1.default.createElement("svg", { className: className, width: width, height: height, viewBox: viewBox, fill: color, xmlns: "http://www.w3.org/2000/svg" }, children));
}
exports.default = Icon;
